import { render, staticRenderFns } from "./recommendationMail.vue?vue&type=template&id=ac2e30f4&scoped=true"
import script from "./recommendationMail.vue?vue&type=script&lang=js"
export * from "./recommendationMail.vue?vue&type=script&lang=js"
import style0 from "./recommendationMail.vue?vue&type=style&index=0&id=ac2e30f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2e30f4",
  null
  
)

export default component.exports